import { ReactNode } from 'react';

interface Props {
  title: string;
  count: number;
  subtitle: string;
  /** Rendered on the same line as the title, right-aligned — the listing
   *  type toggle and program count for the section it heads. */
  actions?: ReactNode;
}

/** A catalogue section title with the number of programs in it. */
export const SectionHeading = ({ title, count, subtitle, actions }: Props) => (
  <div className="flex flex-col gap-1">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <h2 className="text-2xl font-semibold text-heading">{title}</h2>
        <span className="flex h-6 min-w-6 items-center justify-center rounded-full bg-border-secondary px-1.5 text-sm font-semibold text-primary">
          {count}
        </span>
      </div>
      {actions}
    </div>
    <p className="text-sm text-muted-foreground">{subtitle}</p>
  </div>
);
